<template>
    <div
        :class="
            `v-treeview-node v-treeview-node--click ${
                hasChildren ? '' : 'v-treeview-node--leaf'
            }`
        "
    >
        <div
            class="v-treeview-node__root"
            :class="{ 'v-treeview-node__clicked': selectedId === value.id }"
        >
            <md-button
                class="md-just-icon md-simple v-treeview-node__toggle"
                :class="{
                    'v-treeview-node__toggle--open': open,
                    'v-treeview-node__toggle--loaded':
                        hasLoaded &&
                        this.value.children != null &&
                        this.value.children.length > 0,
                    'v-treeview-node__toggle--empty':
                        hasLoaded &&
                        (this.value.children == null ||
                            this.value.children.length == 0)
                }"
                @click="handleOpen()"
            >
                <i class="fas fa-spinner fa-spin" v-if="open && !hasLoaded"></i>
                <md-icon v-else>
                    play_arrow
                </md-icon>
            </md-button>
            <div class="float-right mt--1" v-if="editable && !checkable">
                <md-button
                    class="md-just-icon md-warning md-simple"
                    @click="editCallback(value)"
                >
                    <md-icon>edit</md-icon>
                </md-button>
                <md-button
                    class="md-just-icon md-danger md-simple"
                    @click.native="deleteCallback(value)"
                >
                    <md-icon>close</md-icon>
                </md-button>
            </div>
            <slot name="prepend" v-bind="{ item: value, open }" />
            <div
                class="v-treeview-node__label md-body-1"
                @click="
                    editable && !checkable ? handleOpen() : clickCallback(value)
                "
            >
                <slot name="label" v-bind="{ item: value, open }">
                    <input
                        type="checkbox"
                        v-bind:checked="value.checked"
                        v-on:change="checkedCurrentItem"
                        v-if="checkable"
                    />

                    <span
                        class="v-treeview-node__id"
                        @click="editable ? handleOpen() : clickCallback(value)"
                        >{{ value.external_id }}</span
                    >
                    {{ value.name }}
                </slot>
            </div>
            <slot name="append" v-bind="{ item: value }" />
        </div>
        <div
            v-if="open"
            class="v-treeview-node__children v-treeview-node__children__draggable"
        >
            <draggable
                :group="group"
                :value="value.children"
                ghost-class="ghost"
                @input="updateValue"
                :disabled="disableDrag"
            >
                <treeview-node
                    v-for="child in value.children"
                    :key="child.id + refresh_count"
                    :group="group"
                    :value="child"
                    :editable="editable"
                    :checkable="checkable"
                    :clickCallback="clickCallback"
                    :openCallback="openCallback"
                    :editCallback="editCallback"
                    :deleteCallback="deleteCallback"
                    :selectedId="selectedId"
                    @input="updateChildValue"
                    @checked="checkedItem"
                    :disableDrag="disableDrag"
                >
                    <template v-slot:prepend="{ item, open }">
                        <slot name="prepend" v-bind="{ item, open }"> </slot>
                    </template>
                    <template v-slot:append="{ item }">
                        <slot name="append" v-bind="{ item }" />
                    </template>
                </treeview-node>
            </draggable>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Draggable from 'vuedraggable'

export default Vue.extend({
    name: 'TreeviewNode',
    components: {
        Draggable
    },
    props: {
        value: {
            type: Object, // as PropType<TreeItem>
            default: () => ({
                id: 0,
                name: '',
                children: []
            })
        },
        root: {
            type: Boolean,
            default: () => false
        },
        group: {
            type: String,
            default: null
        },
        editable: {
            type: Boolean,
            default: false
        },
        checkable: {
            type: Boolean,
            default: false
        },
        initOpened: {
            type: Boolean,
            default: false
        },
        clickCallback: {
            type: Function
        },
        openCallback: {
            type: Function
        },
        editCallback: {
            type: Function
        },
        deleteCallback: {
            type: Function
        },
        selectedId: {
            type: Number
        },
        disableDrag: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            open: false,
            hasLoaded: false,
            refresh_count: 0,
            localValue: { ...this.value }
        }
    },
    created() {
        this.localValue = { ...this.value }
        if (this.initOpened) {
            this.handleOpen()
        }
    },
    computed: {
        hasChildren() {
            return this.value.children != null && this.value.children.length > 0
        }
    },
    watch: {
        value(value) {
            this.localValue = { ...value }
        }
    },
    methods: {
        updateValue(value) {
            /*this.localValue.children = [...value]
            this.$emit('input', this.localValue)*/
        },
        updateChildValue(value) {
            /*const index = this.localValue.children.findIndex(
                c => c.id === value.id
            )
            this.$set(this.localValue.children, index, value)
            this.$emit('input', this.localValue)*/
        },
        async checkedCurrentItem(event) {
            this.$emit('checked', {
                id: this.value.id,
                checked: event.target.checked
            })
            if (Array.isArray(this.value.children)) {
                this.value.children.forEach(
                    e => (e.checked = event.target.checked)
                )
                this.localValue.children = this.value.children
            }
            this.refresh_count += 1
            if (!this.hasLoaded && this.openCallback) {
                await this.openCallback(this.value)
                this.hasLoaded = true
                this.open = true
            } else this.open = true
        },

        checkedItem(value) {
            this.$emit('checked', { id: this.value.id, child: value })
        },

        async handleOpen() {
            this.open = !this.open
            if (this.open && !this.hasLoaded && this.openCallback) {
                await this.openCallback(this.value)
                this.hasLoaded = true
            }
        }
    }
})
</script>
<style scoped>
.v-treeview-node__root {
    padding: 10px 15px;
    margin: 0;
}
.v-treeview-node__root:hover {
    background-color: #f2f2f2;
}
.v-treeview-node__children {
    margin-left: 30px;
}
.v-treeview-node__clicked {
    background-color: #f2f2f2;
}
.v-treeview-node__label {
    cursor: pointer;
}

.v-treeview-node__toggle {
    float: left;
    margin-top: -0.5em;
}
.v-treeview-node__toggle .md-icon {
    transition: all 0.3s ease-in-out;
    opacity: 0.5;
}
.v-treeview-node__toggle--open .md-icon {
    transform: rotate(90deg);
}
.v-treeview-node__toggle--loaded .md-icon {
    opacity: 1;
}
.v-treeview-node__toggle--empty .md-icon {
    opacity: 0;
}

.v-treeview-node__id {
    padding: 0 10px 0 10px;
    opacity: 0.5;
}
@media (max-width: 600px) {
    .v-treeview-node {
        font-size: 10px;
    }
    .v-treeview-node__root,
    .v-treeview-node__children {
        padding: 0;
        margin-left: 10px;
    }
    .v-treeview-node__id {
        padding: 0 5px 0 5px;
    }
}
</style>
